<template>
  <Component
    :is="`h${level}`"
    class="s-heading"
    :class="[
      `s-heading-${size}`,
      `s-heading--${color}`,
      { 's-heading--centered': centered },
    ]"
  >
    <slot />
  </Component>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    centered?: boolean;
    color?: "gray" | "primary" | "white";
    level: "1" | "2" | "3" | "4" | "5";
    size: "1" | "2" | "3" | "4" | "5";
  }>(),
  { color: "gray" },
);
</script>

<style lang="postcss">
.s-heading {
  @apply block font-secondary;

  &--centered {
    @apply text-center;
  }

  &::first-letter {
    @apply uppercase;
  }

  &--gray {
    @apply text-slate-700;
  }

  &--primary {
    @apply text-primary-700;
  }

  &--white {
    @apply text-white;
  }
}

.s-heading-1 {
  @apply mb-3 text-4xl font-extrabold;

  @screen 800 {
    @apply text-5xl;
  }

  @screen 1000 {
    @apply text-6xl;
  }
}

.s-heading-2 {
  @apply mb-2 text-2xl font-bold;

  @screen 800 {
    @apply text-3xl;
  }
}

.s-heading-3 {
  @apply mb-2 text-lg font-bold;

  @screen 600 {
    @apply text-xl;
  }
}

.s-heading-4 {
  @apply mb-1 text-base font-bold;

  @screen 600 {
    @apply text-lg;
  }
}

.s-heading-5 {
  @apply mb-1 text-sm font-bold;

  @screen 600 {
    @apply text-base;
  }

  @screen 800 {
    @apply text-lg;
  }
}
</style>
